import { Button, Flex, Input, Skeleton } from "antd";
import ReusableTable from "../../Reuseable/ReusableTable/ReusableTable";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchTelecallerFieldAgents } from "../../store/telecaller/cases";
import { useNavigate } from "react-router-dom";


const FieldAgentAllocation = () => {
    const { telecaller_field_agents, telecaller_field_agents_loading } = useSelector(state => state.telecallerCases)
    const dispatch = useDispatch();
    const navigate = useNavigate();
     const [params, setParams] = useState({
        search: ''
    })
    useEffect(() => {
        dispatch(fetchTelecallerFieldAgents(params))
    }, [dispatch,params])
    const handleViewClick = (record) => {
navigate(`/allocated-cases/${record.id}`)
    }
    const column = [
        {
            title: 'Full Name',
            dataIndex: 'name',
            key: 'name',
            render:(text)=> telecaller_field_agents_loading ? <Skeleton.Input size="small" active/> : text || 'NA'

        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            render:(text)=> telecaller_field_agents_loading ? <Skeleton.Input size="small" active/> : text || 'NA'

        },
        {
            title: 'Role',
            dataIndex: 'role',
            key: 'role',
            render:(text)=> telecaller_field_agents_loading ? <Skeleton.Input size="small" active/> : text || 'NA'

        },
        {
            title: 'Allocations',
            dataIndex: 'allocated_count',
            key: 'allocated_count',
            render:(text)=> telecaller_field_agents_loading ? <Skeleton.Input size="small" active/> : text || 'NA'

        },
        {
            title: 'Ations',
            dataIndex: 'full_name',
            key: 'full_name',
            render: (text,record) => telecaller_field_agents_loading ? <Skeleton.Input size="small" active/> : <Button
                type="default"
                danger
                className="viewBtn"
                size="small"
                style={{ display: 'flex', alignItems: 'center', height: '30px', padding: '0px 10px' }}
                onClick={() => handleViewClick(record)}
            >
                View Details
            </Button>

        },


    ]

    return (

        <div className="allocationPage">
            <Flex justify="space-between" align="center" className="allocationHeader">
                <Flex className="headerLeft">
                    {true && (
                        <Input
                            placeholder="Search"
                            allowClear
                            className="searchInput"
                        //   prefix={<SearchICon />}
                        //   onChange={(e) => setSearchInput(e.target.value)}
                          onPressEnter={(e) => {
                            const value = e.target.value;
                            setParams((prev) => ({
                              ...prev,
                              search: value,
                            
                            }));
                          }}
                          onClear={()=>{
                            setParams((prev)=>({
                                ...prev,
                                search:''
                            }))
                          }}
                        />
                    )}

                </Flex>
            </Flex>
            <ReusableTable
                columns={column}
                dataSource={telecaller_field_agents_loading ? Array(5).fill({}) : telecaller_field_agents?.data}
            // columns={
            //   selectedTab === "Unallocated" ? unallocatedColumns : allocatedColumns
            // }
            // dataSource={
            //   loading
            //     ? Array(5)
            //       .fill(0)
            //       .map((_, i) => ({ id: `skeleton-${i}` }))
            //     : selectedTab === "Unallocated"
            //       ? unAllocatedCasesData
            //       : allocatedCasesData
            // }
            // totalItems={
            //   selectedTab === "Unallocated" ? unAllocatedCount : allocatedCount
            // }
            // rowKey="id"
            // rowSelection={customRowSelection}
            // onRowClick={onRowClick}
            // pointer={pointer}
            // CurrentPageNo={currentPage}
            // pageSize={pageSize}
            // triggerChange={(page, size) => {
            //   onPaginationChange(page, size);
            //   setCurrentPage(page);
            //   setPageSize(size);
            // }}
            />
        </div>
    );
};

export default FieldAgentAllocation;
